import React from 'react';
import { useField, useFormikContext } from 'formik';
import { NSInput } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { useAttributeSuggested } from 'components/DealForm/hooks/useSuggestedAttribute';
import { DefaultAttributes } from '../../../types';

interface CoordinatesInputProps {
    attribute: DefaultAttributes;
    showSuggestedOnly: boolean;
    className?: string;
    onCoordinatesChange?: (lat: number, lng: number) => void;
}

const CoordinatesInput: React.FC<CoordinatesInputProps> = ({
    attribute,
    showSuggestedOnly,
    className = '',
    onCoordinatesChange,
}) => {
    const [latField, latMeta] = useField('latitude');
    const [lngField, lngMeta] = useField('longitude');
    const { setFieldValue } = useFormikContext();

    const { isRequired, shouldRender } = useAttributeSuggested({
        attribute,
        showSuggestedOnly,
    });

    const handleChange = (field: 'latitude' | 'longitude', value: string) => {
        setFieldValue(field, value);

        if (onCoordinatesChange) {
            const lat = field === 'latitude' ? Number(value) : Number(latField.value);
            const lng = field === 'longitude' ? Number(value) : Number(lngField.value);
            onCoordinatesChange(lat, lng);
        }
    };

    const latitudeError = latMeta.touched && latMeta.error ? latMeta.error : null;
    const longitudeError = lngMeta.touched && lngMeta.error ? lngMeta.error : null;

    return (
        <RenderIf isTrue={shouldRender}>
            <div className={`d-flex ${className}`}>
                <div className="w-50 mr-2">
                    <NSInput
                        type="number"
                        name="latitude"
                        label="Latitude"
                        placeholder="Enter latitude"
                        value={latField.value ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('latitude', e.target.value)}
                        onBlur={latField.onBlur}
                        errorMsg={latitudeError}
                        showErrorMsg={!!latitudeError}
                        required={isRequired}
                    />
                </div>
                <div className="w-50">
                    <NSInput
                        type="number"
                        name="longitude"
                        label="Longitude"
                        placeholder="Enter longitude"
                        value={lngField.value ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('longitude', e.target.value)}
                        onBlur={lngField.onBlur}
                        errorMsg={longitudeError}
                        showErrorMsg={!!longitudeError}
                        required={isRequired}
                    />
                </div>
            </div>
        </RenderIf>
    );
};

export default CoordinatesInput;
